import { api } from "./api";

export async function uploadDancerThumbnail(dancerId, file) {
  const form = new FormData();
  form.append("thumbnail", file);
  const r = await api.post(`/dancers/${dancerId}/thumbnail`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return r.data.dancer;
}

export async function deleteDancerThumbnail(dancerId) {
  const r = await api.delete(`/dancers/${dancerId}/thumbnail`);
  return r.data.dancer;
}

export async function uploadOrganizerThumbnail(file) {
  const form = new FormData();
  form.append("thumbnail", file);
  const r = await api.post("/organizers/me/thumbnail", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return r.data.organizer;
}

export async function deleteOrganizerThumbnail() {
  const r = await api.delete("/organizers/me/thumbnail");
  return r.data.organizer;
}

export async function uploadProfileThumbnails({ dancerId, organizerSignedIn, file }) {
  let dancer = null;
  let organizer = null;
  if (dancerId) {
    dancer = await uploadDancerThumbnail(dancerId, file);
  }
  if (organizerSignedIn) {
    organizer = await uploadOrganizerThumbnail(file);
  }
  return { dancer, organizer };
}

export async function deleteProfileThumbnails({ dancerId, organizerSignedIn }) {
  let dancer = null;
  let organizer = null;
  if (dancerId) {
    dancer = await deleteDancerThumbnail(dancerId);
  }
  if (organizerSignedIn) {
    organizer = await deleteOrganizerThumbnail();
  }
  return { dancer, organizer };
}
